import React from 'react'
import { RadioButton } from '../../common/RadioButton'
import { ResultBar } from './ResultBar'
import { Spinner } from '../../common/Spinner'
import { PostPollOption } from '../../../generated/api/post-row'

interface PollProps {
  option: PostPollOption
  totalVotes: number
  index: number
  showResult: boolean
  selectedValue: string | null
  setSelectedValue: React.Dispatch<React.SetStateAction<string | null>>
  vote: (option: PostPollOption) => void
  loading?: boolean
  disabled?: boolean
}

export const Poll = ({
  option,
  totalVotes,
  index,
  showResult,
  selectedValue,
  setSelectedValue,
  vote,
  loading,
  disabled,
}: PollProps): JSX.Element => {
  const onClick = (): void => {
    if (!disabled) {
      setSelectedValue(option.text)
      vote(option)
    }
  }

  return showResult ? (
    <ResultBar option={option} totalVotes={totalVotes} />
  ) : (
    <button
      tabIndex={index}
      className={`flex h-[50px] items-center rounded-md border border-neutral-80 p-3
        ${
          option.text === selectedValue
            ? 'border-brandGreen'
            : 'border-neutral-80'
        }
      `}
      onClick={onClick}
      disabled={loading}
    >
      <div className="flex w-fit">
        {loading && option.text === selectedValue ? (
          <Spinner />
        ) : (
          <RadioButton
            name={option.text}
            label={option.text}
            value={option.text}
            checked={option.text === selectedValue}
            onChange={onClick}
            disabled={loading || disabled}
          />
        )}
      </div>
    </button>
  )
}
